<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="日期：" prop="start_day">
                <span>{{model.start_day}} 至 {{model.end_day}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="行驶次数：" prop="drive_count">
                <span>{{model.drive_count}}次</span>
            </el-form-item>
            <el-form-item label="行驶里程：" prop="mileage">
                <span>{{model.mileage}}km</span>
            </el-form-item>
            <el-form-item label="消耗：" prop="consume">
                <span>{{model.consume}}度</span>
            </el-form-item>
            <el-form-item label="费用：" prop="fee">
                <span>{{model.fee}}元</span>
            </el-form-item>
            <el-form-item label="平均速度：" prop="avg_speed">
                <span>{{model.avg_speed}}km/h</span>
            </el-form-item>
            <el-form-item label="平均能耗：" prop="avg_enc">
                <span>{{model.avg_enc}}wh/km</span>
            </el-form-item>
            <el-form-item label="充电次数：" prop="charge_count">
                <span>{{model.charge_count}}次</span>
            </el-form-item>
            <el-form-item label="充入电量：" prop="charge_in">
                <span>{{model.charge_in}}度</span>
            </el-form-item>
            <el-form-item label="生成时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="是否发送：" prop="is_send">
                <span>{{ transEnu(model.is_send, "yesNo")}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'carWeekInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                start_day: '',
                end_day: '',
                member_id: '',
                email: '',
                car_info_id: '',
                car_id: '',
                vehicle_id: '',
                drive_count: '',
                mileage: '',
                consume: '',
                fee: '',
                avg_speed: '',
                avg_enc: '',
                charge_count: '',
                charge_in: '',
                add_time: '',
                is_send: '',
            },
            getObj:{
                url:'/api/admin/carweek/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
        };
    },
    methods: {
        formateData() {
            let temp_avg_enc = this.model.avg_enc*10
            this.model.avg_enc = temp_avg_enc.toFixed(2)
        },
    }
};
</script>